import { ManagePracticeService } from 'src/app/manage-practice/manage-practice.service';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterEvent, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';

import { Component, OnInit, NgZone } from '@angular/core';
import { filter, window } from 'rxjs/operators';
import { CustomLoadingService } from './shared/custom-loading/custom-loading.service';

declare var myExtObject: any;
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
	loggedInUser: any;
	constructor(
		private ngZone: NgZone,
		private loadingService: CustomLoadingService,
		private route: ActivatedRoute, private router: Router,
		private translate: TranslateService,
		private appSettingService: AppSettingService,
		private managePracticeService: ManagePracticeService
	) {
		window["angularComponentRef"] = { component: this, zone: ngZone };
		this.route.data.subscribe(data =>
			document.getElementsByTagName("body")[0].classList.add(data.activeClass)
		);

		this.translate.use(this.appSettingService.currentLanguage || 'en')

		myExtObject.executeStartScript();
	}
	ngOnInit() {

		this.router.events.pipe(
			filter((e: any) => e instanceof NavigationStart)
		).subscribe((e: RouterEvent) => {
			this.loadingService.show();

		});
		this.router.events.pipe(
			filter((e: any) => e instanceof NavigationEnd)
		).subscribe((e: RouterEvent) => {
			this.loadingService.hide();
			setTimeout(() => {
				try {
					if (this.appSettingService.isAuthenticated) {
						// this.managePracticeService.getBadges().subscribe(res => {
						// 	setTimeout(() => {
						// 		myExtObject.UpdateBadgeCount(res);
						// 	},50);
						// });
					}
				}
				catch (ex) { }
				myExtObject.executeStartScript();
			}, 0);
		});
	}
}
